import { Injectable } from '@angular/core';
import { HiddenQuestion, QuestionGroup, TextboxQuestion, DropdownQuestion, RadiobuttonQuestion } from 'core/index';
import { GroupQuestion } from '../models/group-question';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ChoicesService {
  constructor(private translateService: TranslateService) {}
  getQuestions(question: GroupQuestion, groupId) {
    const choices = question && question.choices ? question.choices : [{}, {}, {}];

    const creationStatuses = [
      { key: 'PUBLISHED', value: this.translateService.instant('questions.status.creation.published') },
      { key: 'CERTIFIED', value: this.translateService.instant('questions.status.creation.certified') }
    ];

    const editionStatuses = [
      { key: 'PUBLISHED', value: this.translateService.instant('questions.status.edition.published') },
      { key: 'DISPUTED', value: this.translateService.instant('questions.status.edition.disputed') },
      { key: 'CERTIFIED', value: this.translateService.instant('questions.status.edition.certified') },
      { key: 'CANCELLED', value: this.translateService.instant('questions.status.edition.cancelled') }
    ];
    const statuses = question ? editionStatuses : creationStatuses;

    const questions = [
      new HiddenQuestion({
        key: 'groupId',
        value: groupId,
        validators: { required: true },
        order: 1
      }),
      new TextboxQuestion({
        key: 'question',
        label: 'customizations.documents.questions.text',
        value: question && question.question ? question.question : null,
        validators: { required: true },
        controlType: 'hidden',
        order: 3,
        eventHandlers: {}
      }),
      new QuestionGroup({
        class: 'col-1',
        disableGrid: true,
        childQuestions: [this.getChoicesTextsQuestions(choices), this.getCorrectChoiceQuestion(choices)]
      }),
      new DropdownQuestion({
        key: 'status',
        options: statuses,
        label: 'nouns.status',
        value: question ? question.status : statuses[0].key,
        order: 5,
        disabled: question ? true : false
      })
    ];

    if (question && question.status === 'DISPUTED') {
      questions.push(
        new TextboxQuestion({
          key: 'disputeReason',
          label: 'customizations.documents.questions.disputeReason',
          editable: false,
          value: question.disputeReason,
          order: 6
        })
      );
    }

    return questions;
  }

  getChoicesTextsQuestions(choices) {
    return new QuestionGroup({
      key: '_choices',
      title: 'nouns.answer',
      class: 'col s9',
      childQuestions: choices.map(
        (choice, index) =>
          new TextboxQuestion({
            key: `_choice_${index + 1}`,
            validators: { required: true },
            value: (choice && choice.text) || null
          })
      )
    });
  }

  getCorrectChoiceQuestion(choices) {
    const correctIndex = choices.findIndex((choice) => choice.isCorrect);
    const correctOption = correctIndex >= 0 ? `${correctIndex + 1}` : null;
    const correctChoiceQuestion = new QuestionGroup({
      title: 'nouns.isCorrect',
      class: 'col s3 center-align',
      childQuestions: [
        new RadiobuttonQuestion({
          key: '_correctChoice',
          class: 'col s2 margin-top',
          validators: { required: true },
          options: [
            { label: '1', value: '1' },
            { label: '2', value: '2' },
            { label: '3', value: '3' }
          ],
          value: correctOption
        })
      ]
    });
    return correctChoiceQuestion;
  }
}
